module.exports = "/_next/static/images/TNM_Sticker4_DarkGrey+Yellow-81f1ecd18f3560efad3664d6ce3e3ae1.svg";